<template>
  <v-card
    v-if="mensagemSelecionadaParaResposta"
    outlined
  >
    <v-card-text class="d-flex justify-space-between align-center">
      <span>{{ mensagemSelecionadaParaResposta.conteudoTexto }}</span>

      <v-btn
        icon
        @click="handleCancelarRespostaMensagem"
      >
        <v-icon>{{ icons.mdiClose }}</v-icon>
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import { mdiClose } from '@mdi/js'

export default {
  props: {
    mensagemSelecionadaParaResposta: {
      type: Object,
      required: true,
    },
    handleCancelarRespostaMensagem: {
      type: Function,
      required: true,
    },
  },

  setup() {
    return {
      icons: {
        mdiClose,
      },
    }
  },
}
</script>
